/**
 * Redirect data types
 */

export const REDIRECT_TYPES = {
  SPACE: 'SPACE',
  PLUGIN: 'PLUGIN',
  PAGE: 'PAGE',
  COMPONENT: 'COMPONENT',
  URL: 'URL'
};

export class RedirectData {
  constructor(data = {}) {
    this.redirect_id = data.redirect_id ?? null;
    this.source_path = data.source_path ?? '';
    this.target_type = data.target_type ?? REDIRECT_TYPES.SPACE;
    this.target_value = data.target_value ?? '';
    this.description = data.description ?? '';
    this.is_active = data.is_active ?? true;
    this.created_at = data.created_at ?? null;
    this.updated_at = data.updated_at ?? null;
  }

  static fromApiResponse(data) {
    return new RedirectData(data);
  }

  static fromApiResponseList(dataList) {
    return dataList.map(item => RedirectData.fromApiResponse(item));
  }
}

export class RedirectLookupResponse {
  constructor(data = {}) {
    this.found = data.found ?? false;
    this.redirect = data.redirect ? new RedirectData(data.redirect) : null;
  }
}








